import { render, staticRenderFns } from "./DisplaySizes.vue?vue&type=template&id=85e58634&"
import script from "./DisplaySizes.vue?vue&type=script&lang=js&"
export * from "./DisplaySizes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports